import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-performance",
  "use": "icon-performance-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-performance\"><path d=\"M409.6 411.648l-409.6 235.52V1024h1024V307.2l-512 281.6-102.4-177.152z\" p-id=\"20144\" /><path d=\"M409.6 226.304l103.424 179.2L870.4 198.656l26.112 45.568L1024 51.2l-230.912 13.824 26.112 45.056-268.8 155.136-103.424-178.688L0 344.576l51.2 88.576 358.4-206.848z\" p-id=\"20145\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol